import { render } from "./PaymentReceiptCreateBottomSection.vue?vue&type=template&id=096e5e06&scoped=true"
import script from "./PaymentReceiptCreateBottomSection.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateBottomSection.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateBottomSection.vue?vue&type=style&index=0&id=096e5e06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096e5e06"]])

export default __exports__